import { getBrand } from '@/utils/brand.util'

import type { BrandT, DeviceClassT, GlobalContextParamsT } from './types'

type GlobalContextT = GlobalContextParamsT

const globalContext: GlobalContextT = {}

const BRAND_BY_WEBSITE: Record<string, BrandT> = {
  'memowrite.com': 'memowrite',
  'writeyourlove.com': 'writeyourlove',
  'holywrite.com': 'holywrite',
}

export const getBrandSlug = (): BrandT | undefined => {
  if (typeof window === 'undefined') return undefined
  return BRAND_BY_WEBSITE[getBrand().website]
}

export const getDeviceClass = (): DeviceClassT | undefined => {
  if (typeof window === 'undefined') return undefined
  const width = window.innerWidth
  if (width < 768) return 'phone'
  if (width < 1024) return 'tablet'
  return 'desktop'
}

export const setAnalyticsContext = (partial: Partial<GlobalContextT>) => {
  for (const [key, value] of Object.entries(partial)) {
    if (value === undefined) continue
    globalContext[key as keyof GlobalContextT] = value as never
  }
}

export const clearAnalyticsContext = () => {
  for (const key of Object.keys(globalContext)) {
    delete globalContext[key as keyof GlobalContextT]
  }
}

export const getAnalyticsContext = (): GlobalContextT => {
  return {
    brand: globalContext.brand ?? getBrandSlug(),
    device_class: globalContext.device_class ?? getDeviceClass(),
    locale: globalContext.locale,
    book_type: globalContext.book_type,
    user_segment: globalContext.user_segment,
    subscription_status: globalContext.subscription_status,
    is_frozen: globalContext.is_frozen,
    book_stage: globalContext.book_stage,
  }
}
